import React from "react";

const ExternalFormsHeader = () => {
  return (
    <>
      <div className="flex items-center justify-between w-full text-purple bg-white m-0 px-3 header border-b-3">
        <h1>Kindergarten Inclusion Support</h1> <div className="vic-logo"></div>
      </div>
    </>
  );
};

export default ExternalFormsHeader;
